import "./Contact.module.css";
import AutoMotiGalvene from "@/reusable_sections/Header";
import StartAProject from "./sections/StartAProject";
import GlobalStudio from "./sections/GlobalStudio";
import ContactInfo from "./sections/ContactInfo";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <AutoMotiGalvene />
      <StartAProject />
      <ContactInfo />
      <GlobalStudio />
      <Footer />
    </div>;
}